export var AnalyticsVideoEventCategory = 'HTML5-Video';
export var AnalyticsYouTubeEventCategory = 'YouTube-Video';
export var AnalyticsAdaptiveVideoEventCategory = 'Adaptive-Video';
export var AnalyticsImageEventCategory = 'Image';
export var AnalyticsRumVideoCategorySuffix = '';
export var AnalyticsRumAdaptiveStreamingCategorySuffix = '_AdaptiveVideo';
